import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SubdomainLinkModule } from '@app/shared/directives/subdomain-link'
import { RegistrationSimpleHeaderComponent } from './registration-simple-header.component'

export { RegistrationSimpleHeaderComponent } from './registration-simple-header.component'

@NgModule({
  imports: [CommonModule, SubdomainLinkModule],
  declarations: [RegistrationSimpleHeaderComponent],
  exports: [RegistrationSimpleHeaderComponent],
  providers: [],
})
export class RegistrationSimpleHeaderModule {}
